import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import Notification from '../../Common/Notification';
import './ReportFooter.scss';
/*
 * Add this to any screen you want the Subscription.ReportPageFooter to show up on when printing
 * This will load up the Subscription.ReportFooter on to the page and keep it hidden until printing
*/
export class ReportFooter extends React.Component {

    constructor(props, context){
        super(props, context);

        this.state = {
            footer: ""
        }
    }

    componentDidMount = () => {
        this.loadFooter();
    }

    loadFooter = async () => {
        try {
            const response = await this.props.subscriptionActions.getReportFooter();
            if (response.type === types.GET_SUBSCRIPTION_REPORT_FOOTER_SUCCESS) {

                this.setState({ footer: response.payload.footer });

            } else if (response.type === types.GET_SUBSCRIPTION_REPORT_FOOTER_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingListFilters: false });
        }
    }

    render(){
        return (
            <div className="report-footer">{this.state.footer}</div>
        );
    }
}

ReportFooter.propTypes = {
    subscriptionActions: PropTypes.object.isRequired
}

export default ReportFooter;